import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\">\n<g clip-path=\"url(#icon-file_clip0_112711_114736)\">\n<path d=\"M42.3552 12.0321L30.8267 0.503572C30.5052 0.182143 30.0713 0 29.616 0H6.85882C5.9106 0 5.14453 0.766071 5.14453 1.71429V46.2857C5.14453 47.2339 5.9106 48 6.85882 48H41.1445C42.0927 48 42.8588 47.2339 42.8588 46.2857V13.2482C42.8588 12.7929 42.6767 12.3536 42.3552 12.0321ZM38.9052 14.0357H28.8231V3.95357L38.9052 14.0357ZM39.0017 44.1429H9.00167V3.85714H25.1802V15.4286C25.1802 16.0253 25.4173 16.5976 25.8393 17.0196C26.2612 17.4415 26.8335 17.6786 27.4302 17.6786H39.0017V44.1429Z\" fill=\"currentColor\" />\n</g>\n<defs>\n<clipPath id=\"icon-file_clip0_112711_114736\">\n<rect width=\"48\" height=\"48\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file.svg
// module id = fQ0v
// module chunks = 6 7